"use strict";

window.addEventListener('DOMContentLoaded',function() {
      const spmenu = document.querySelector(".spmenu");

      if(spmenu === null) return;

      spmenu.addEventListener("click", function() {
            document.body.classList.toggle("is-open");
      });
      spmenu.querySelectorAll("a").forEach(function(link) {
            link.addEventListener("click", function() {
                  document.body.classList.remove("is-open");
            });
      });
      document.addEventListener("click", function(event) {
            if(!spmenu.contains(event.target)) {
                  document.body.classList.remove("is-open");
            }
      });
});
